// Adding a Meshulam card sends the donor to Meshulam's page and back. The
// registration they left with is kept here so the payment page can check its
// result when they return.
const REGISTRATION_KEY = "donor_meshulam_card_registration";

// Query parameter Meshulam's return URLs carry: "done" or "cancelled".
export const MESHULAM_RETURN_PARAM = "meshulam_card";

export function rememberMeshulamRegistration(reference) {
  try {
    sessionStorage.setItem(REGISTRATION_KEY, reference);
  } catch {
    // storage unavailable: the payment page then just reloads the cards
  }
}

export function takeMeshulamRegistration() {
  try {
    const reference = sessionStorage.getItem(REGISTRATION_KEY);
    sessionStorage.removeItem(REGISTRATION_KEY);
    return reference || "";
  } catch {
    return "";
  }
}
